export default __webpack_public_path__ + "c953863ad3a63d3d05f87dc41d27e54b.png";